(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('reports', {
                parent: 'entity',
                url: '/reports',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CLIENT'],
                    pageTitle: 'Reports'
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/advices/reports/reports.html',
                    controller: 'ReportsController',
                    controllerAs: 'vm'
                  }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    status: ['$stateParams', 'AdviceStatus', function($stateParams, AdviceStatus) {
                        return AdviceStatus.query().$promise;
                    }]
                }
            })
            .state('reports.edit', {
                parent: 'reports',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CLIENT'],
                    pageTitle: 'Reports'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/advices/reports/reports-detail.html',
                        controller: 'ReportsDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                      label: 'Administrar',
                      parent: 'reports'
                },
                resolve: {
                    entity: ['$stateParams', 'Advice', function($stateParams, Advice) {
                        return Advice.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    advicestatus: ['$stateParams', 'AdviceStatus', function($stateParams, AdviceStatus) {
                        return AdviceStatus.query().$promise;
                    }],
                    previousState: ["$state", function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'reports',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('reports.new', {
                parent: 'reports',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                  'content@': {
                    templateUrl: 'app/entities/advices/reports/reports-new.html',
                    controller: 'ReportsNewController',
                    controllerAs: 'vm'
                  }
                },
                ncyBreadcrumb: {
                      label: 'Nuevo',
                      parent: 'reports'
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    advicestatus: ['$stateParams', 'AdviceStatus', function($stateParams, AdviceStatus) {
                        return AdviceStatus.query().$promise;
                    }],
                    previousState: ["$state", function ($state) {
                          var currentStateData = {
                              name: $state.current.name || 'reports',
                              params: $state.params,
                              url: $state.href($state.current.name, $state.params)
                          };
                          return currentStateData;
                    }]
                }
            });
    }

})();
